export default __webpack_public_path__ + "static/media/phasor-variable-frequency.61a25319.gif";